module.exports = __webpack_public_path__ + "9788f41e/img/mini-logo.18817ee5.svg";